import { Provider } from 'mobx-react';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Modal from 'react-modal';
import Root from './components/Root';
import stores from './stores';
import './styles/fonts.styl';

const init = () => {
    const root = document.getElementById('root');
    Modal.setAppElement(root);

    ReactDOM.render((
        <Provider {...stores}>
            <Root />
        </Provider>
    ), root);
};

window.onload = init;

if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}
